"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.DelegatePay__factory = void 0;
var ethers_1 = require("ethers");
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "dest",
                type: "address"
            },
            {
                indexed: false,
                internalType: "contract IERC20",
                name: "payToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
        ],
        name: "DelegatePaid",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dest",
                type: "address"
            },
            {
                internalType: "contract IERC20",
                name: "payToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
        ],
        name: "delegatePay",
        outputs: [
            {
                internalType: "bytes",
                name: "result",
                type: "bytes"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
];
var _bytecode = "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";
var DelegatePay__factory = /** @class */ (function (_super) {
    __extends(DelegatePay__factory, _super);
    function DelegatePay__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (args.length === 1) {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        else {
            _this = _super.apply(this, args) || this;
        }
        return _this;
    }
    DelegatePay__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    DelegatePay__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    DelegatePay__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    DelegatePay__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    DelegatePay__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    DelegatePay__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    DelegatePay__factory.bytecode = _bytecode;
    DelegatePay__factory.abi = _abi;
    return DelegatePay__factory;
}(ethers_1.ContractFactory));
exports.DelegatePay__factory = DelegatePay__factory;
